import { render, staticRenderFns } from "./DataTableFilter.vue?vue&type=template&id=2addd710&scoped=true&"
import script from "./DataTableFilter.vue?vue&type=script&lang=js&"
export * from "./DataTableFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2addd710",
  null
  
)

export default component.exports